import { CoinsIcon, SparklesIcon, Zap } from 'lucide-react';
import { cn } from '@/utils';
import { getModelCredits } from '@/config/models';
import CreditsIcon from './icons/CreditsIcon';

interface CreditDisplayProps {
  selectedModelId?: string;
  userCreditsRemaining?: number;
  userTier: 'free' | 'pro' | 'ultimate';
  className?: string;
}

export default function CreditDisplay({
  selectedModelId,
  userCreditsRemaining,
  userTier,
  className,
}: CreditDisplayProps) {
  const creditsNeeded = selectedModelId ? getModelCredits(selectedModelId) : 1;
  const canGenerate = userCreditsRemaining === undefined || userCreditsRemaining >= creditsNeeded;

  return (
    <div
      className={cn(
        'flex items-center gap-1 px-2 py-1 rounded-md text-xs',
        canGenerate ? 'text-gray-500 dark:text-gray-400' : 'text-red-700 dark:text-red-400',
        className
      )}
    >
      <CreditsIcon className="h-3.5 w-3.5 -mt-[1px]" />
      <span className="font-medium">
        {creditsNeeded} credit{creditsNeeded !== 1 ? 's' : ''}
      </span>
    </div>
  );
}
